import { render, staticRenderFns } from "./LineMiniappLogin.vue?vue&type=template&id=5024e4ba&scoped=true"
import script from "./LineMiniappLogin.vue?vue&type=script&lang=js"
export * from "./LineMiniappLogin.vue?vue&type=script&lang=js"
import style0 from "./LineMiniappLogin.vue?vue&type=style&index=0&id=5024e4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024e4ba",
  null
  
)

export default component.exports